// react
import React, { useEffect, useState, lazy } from "react";
import { useSelector, useDispatch } from "react-redux";

// third-party
import PropTypes from "prop-types";

// application
import PageHeader from "../shared/PageHeader";
import { getProductDetails, getProductList } from "../../api/product";
import { getNoImg, makeSEOtag, redirectTo404, url } from "../../services/utils";

// blocks
import BlockLoader from "../blocks/BlockLoader";
import BlockProductsCarousel from "../blocks/BlockProductsCarousel";

// data stubs
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import { getEventByProduct } from "../../api/event";
import BlockProductAddOnDeals from "../blocks/BlockProductAddOnDeals";
import BlockProductComboDeals from "../blocks/BlockProductComboDeals";
import { eventTypeList } from "../../data/generalData";
const cookies = new Cookies();
const ProductTabs = lazy(() => import("./ProductTabs"));
const Product = lazy(() => import("../shared/Product"));
let prevCategory = "";
function ShopPageProduct(props) {
    const { productSlug, layout, sidebarPosition } = props;

    const [isLoading, setIsLoading] = useState(true);
    const [product, setProduct] = useState(null);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [relatedProductsLoading, setRelatedProductsLoading] = useState(true);
    const history = useHistory();
    const [refresh, setRefresh] = useState(0);
    const [eventData, setEventData] = useState(null);
    const [visibleCat, setVisibleCat] = useState("");
    const [breadcrumb, setBreadcrumb] = useState([]);

    let whastappNumber = useSelector((state) => state.generalInfo?.info?.contact_info?.whastapp);
    let categories = useSelector((state) => state.generalInfo?.categories);

    useEffect(() => {
        return () => {
            const state = props.location.state;
            if (state) {
                if (
                    window?.location.pathname.indexOf("/category/") > -1 ||
                    window?.location.pathname.indexOf("/brand/") > -1 ||
                    window?.location.pathname.indexOf("/search-products") > -1
                ) {
                    var expiryDate = new Date();
                    expiryDate.setMinutes(expiryDate.getMinutes() + 10);
                    cookies.set("list", productSlug + ":" + state.location + ":" + state.page, { expires: expiryDate });
                }
            }
        };
    }, []);

    useEffect(() => {
        if (product) {
            let temp = [{ title: "Home", url: url.home() }];
            if (product?.brand_info?.slug) {
                temp.push({
                    title: product?.brand_info?.name,
                    url: url.brand(product?.brand_info),
                });
            }

            temp.push(
                {
                    title: visibleCat ? visibleCat?.name : product?.product_category_info.name,
                    url: url.category(visibleCat ? visibleCat : product?.product_category_info),
                },
                { title: product.name, url: url.product(product) }
            );
            setBreadcrumb(temp);
        }
    }, [product, visibleCat]);

    async function recursiveCategory(cat, matchSlug) {
        let found = null;
        try {
            cat?.forEach((item) => {
                if (item.child?.length > 0) {
                    found = item.child.find((childItem) => childItem.slug == matchSlug);
                    if (found) {
                        if (found.is_visible) {
                            found = null;
                            throw "category is visible";
                        } else if (item.is_visible) {
                            found = item;
                            throw "break";
                        } else {
                            recursiveCategory(categories, item.slug);
                        }
                    } else {
                        found = recursiveCategory(item.child, matchSlug);
                    }
                }
            });
        } catch (e) {
            console.log(e)
            setVisibleCat(found);
            return found;
        }
    }

    useEffect(() => {
        if (categories && product?.product_category_info?.slug) {
            recursiveCategory(categories, product?.product_category_info?.slug);
        }
    }, [categories, product?.product_category_info?.slug]);

    // Load product.
    useEffect(() => {
        setIsLoading(true);
        getProductDetails(productSlug)
            .then((res) => {
                if (res.data) {
                    setProduct(res.data);
                    getProductList({
                        sort_by: "rand",
                        per_page: 6,
                        exclude_list: res.data.uuid,
                        product_category: res.data?.product_category_info?.slug,
                    }).then((res) => {
                        if (res.data && res.data.data) setRelatedProducts(res.data);
                        setRelatedProductsLoading(false);
                    });

                    if (
                        res.data.variant_choices[0] &&
                        res.data.variant_choices[0].stock_count > 0 &&
                        res.data.variant_choices[0].is_pwp_event &&
                        (res.data.progression == "ongoing" || res.data.progression == null)
                    ) {
                        getEventByProduct(productSlug).then((res) => {
                            setEventData(res.data);
                        });
                    } else setEventData(null);

                    setIsLoading(false);
                } else {
                    redirectTo404();
                }
            })
            .catch((err) => {
                redirectTo404();
            });
    }, [productSlug, refresh]);

    if (isLoading) {
        return (
            <div className="block-empty-page">
                <BlockLoader />
            </div>
        );
    }

    let content;

    content = (
        <React.Fragment>
            <div className="block">
                <div className="container">
                    <Product
                        product={product}
                        layout={layout}
                        whastappNumber={whastappNumber}
                        history={history}
                        eventData={eventData}
                        refreshProduct={() => setRefresh(refresh + 1)}
                    />

                    {(eventData?.event_type && product.progression == "ongoing") || product.progression == null ? (
                        eventData?.event_type.code == eventTypeList.find((item) => item.name == "PWP Bundle").code ? (
                            <BlockProductAddOnDeals product={product} eventData={eventData} history={history} />
                        ) : eventData?.event_type.code == eventTypeList.find((item) => item.name == "PWP Combo").code ? (
                            <BlockProductComboDeals product={product} eventData={eventData} history={history} />
                        ) : null
                    ) : null}

                    <ProductTabs product={product} />
                </div>
            </div>
            {relatedProducts.data?.length > 0 ? (
                <div>
                    <BlockProductsCarousel
                        title="You May Also Likes"
                        layout="grid-6"
                        type="default"
                        products={relatedProducts?.data}
                        loading={relatedProductsLoading}
                    />
                </div>
            ) : null}
        </React.Fragment>
    );

    return (
        <React.Fragment>
            {makeSEOtag(
                product.meta_title ? product.meta_title : product.name,
                product.meta_description ? product.meta_description : product.short_description ? product.short_description : product.name,
                product.meta_keywords,
                product.images && product.images[0]
                    ? product.images[0].responsive_url[product.images[0].responsive_url?.length - 1]
                    : getNoImg("small")
            )}
            <PageHeader breadcrumb={breadcrumb} />

            {content}
        </React.Fragment>
    );
}

ShopPageProduct.propTypes = {
    /** Product slug. */
    productSlug: PropTypes.string,
    /** one of ['standard', 'sidebar', 'columnar', 'quickview'] (default: 'standard') */
    layout: PropTypes.oneOf(["standard", "sidebar", "columnar", "quickview"]),
    /**
     * sidebar position (default: 'start')
     * one of ['start', 'end']
     * for LTR scripts "start" is "left" and "end" is "right"
     */
    sidebarPosition: PropTypes.oneOf(["start", "end"]),
};

ShopPageProduct.defaultProps = {
    layout: "standard",
    sidebarPosition: "start",
};

export default ShopPageProduct;
